import { ContentTableItem } from "src/components/ContentTable/ContentTable";

export function mapGroupsToContentTableItems(
	groups: Group[]
): ContentTableItem[] {
	return groups.map((group) => ({
		id: group.id,
		name: group.name,
		isActive: true,
		lastUpdated: group.updatedAt,
		data: {
			memberCount: group.memberCount,
			description: group.description
		}
	}));
}
